// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#do-list-container {
    margin-top: min(8%, 55px);
    flex-grow: 4;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
.do-list-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 30vw;
}
#do-list-header {
    width: 30vw;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
}
#do-list-title {
    font-size: 1.6rem;
    /* font-family: 'Poppins Medium'; */
    width: 30vw;
}
#do-list-nav {
    display: flex;
    flex-direction: row;
    width: 30vw;
}
.do-list-subtitle {
    font-size: 1.2rem;
    align-self: center;
}
.do-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow-y: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

@media only screen and (max-width: 600px) {
    #do-list-nav {
        width: 100%;
    }
    #do-list-header {
        width: 100%;
        gap: 5%;
        display: flex;
        align-items: center;
    }
    #do-list-title {
        font-size: 1.6rem;
        /* font-family: 'Poppins Medium'; */
        width: 100%;
        margin-right: auto;
    }
    #do-list-container {
        margin-top: min(8%, 55px);
        margin-right: 5%;
        display: flex;
        flex-direction: column;
        gap: 0.7rem;
        width: 100%;
        justify-content: center;
        align-items: center;
    }
    .do-list-container {
        width: 100%;
        height: 100%;
        margin-left: 10vw;
        margin-right: 5vw;
    }
}
@media only screen and (min-width:601px)  { 
    /* tablet, landscape iPad, lo-res laptops ands desktops */ 
    #do-list-nav {
        width: 100%;
    }
    #do-list-header {
        width: 100%;
        gap: 5%;
        display: flex;
        align-items: center;
    }
    #do-list-title {
        font-size: 2rem;
        /* font-family: 'Poppins Medium'; */
        margin-right: auto;
    }
    .do-list-container {
        width: 90%;
        height: 100%;
        margin-right: 5vw;
    }
    .do-list-subtitle {
        font-size: 1.5rem;
    }
}
@media only screen and (min-width:962px) { 
    /* big landscape tablets, laptops, and desktops */ 
    #do-list-nav {
        width: 100%;
    }
    #do-list-header {
        width: 100%;
        gap: 5%;
        display: flex;
        align-items: center;
    }
    #do-list-title {
        font-size: 2.4rem;
        /* font-family: 'Poppins Medium'; */
        margin-right: auto;
    }
    .do-list-container {
        width: 90%;
        height: 100%;
        margin-right: 5vw;
    }
    .do-list-subtitle {
        font-size: 1.7rem;
    }
}
@media (min-width:1281px) {
    /* hi-res laptops and desktops */
    #do-list-title {
        font-size: 3rem;
    }
    .do-list-container {
        width: 75%;
    }
    #do-list-nav {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/to-do-list.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;AACf;AACA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,mCAAmC;IACnC,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB,GAAG,YAAY;AACxC;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,OAAO;QACP,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,iBAAiB;QACjB,mCAAmC;QACnC,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,WAAW;QACX,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,iBAAiB;IACrB;AACJ;AACA;IACI,yDAAyD;IACzD;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,OAAO;QACP,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,mCAAmC;QACnC,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI,iDAAiD;IACjD;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,OAAO;QACP,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,iBAAiB;QACjB,mCAAmC;QACnC,kBAAkB;IACtB;IACA;QACI,UAAU;QACV,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI,gCAAgC;IAChC;QACI,eAAe;IACnB;IACA;QACI,UAAU;IACd;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":["#do-list-container {\n    margin-top: min(8%, 55px);\n    flex-grow: 4;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n.do-list-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    width: 30vw;\n}\n#do-list-header {\n    width: 30vw;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: flex-start;\n}\n#do-list-title {\n    font-size: 1.6rem;\n    /* font-family: 'Poppins Medium'; */\n    width: 30vw;\n}\n#do-list-nav {\n    display: flex;\n    flex-direction: row;\n    width: 30vw;\n}\n.do-list-subtitle {\n    font-size: 1.2rem;\n    align-self: center;\n}\n.do-list {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    overflow-y: scroll;\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n}\n\n@media only screen and (max-width: 600px) {\n    #do-list-nav {\n        width: 100%;\n    }\n    #do-list-header {\n        width: 100%;\n        gap: 5%;\n        display: flex;\n        align-items: center;\n    }\n    #do-list-title {\n        font-size: 1.6rem;\n        /* font-family: 'Poppins Medium'; */\n        width: 100%;\n        margin-right: auto;\n    }\n    #do-list-container {\n        margin-top: min(8%, 55px);\n        margin-right: 5%;\n        display: flex;\n        flex-direction: column;\n        gap: 0.7rem;\n        width: 100%;\n        justify-content: center;\n        align-items: center;\n    }\n    .do-list-container {\n        width: 100%;\n        height: 100%;\n        margin-left: 10vw;\n        margin-right: 5vw;\n    }\n}\n@media only screen and (min-width:601px)  { \n    /* tablet, landscape iPad, lo-res laptops ands desktops */ \n    #do-list-nav {\n        width: 100%;\n    }\n    #do-list-header {\n        width: 100%;\n        gap: 5%;\n        display: flex;\n        align-items: center;\n    }\n    #do-list-title {\n        font-size: 2rem;\n        /* font-family: 'Poppins Medium'; */\n        margin-right: auto;\n    }\n    .do-list-container {\n        width: 90%;\n        height: 100%;\n        margin-right: 5vw;\n    }\n    .do-list-subtitle {\n        font-size: 1.5rem;\n    }\n}\n@media only screen and (min-width:962px) { \n    /* big landscape tablets, laptops, and desktops */ \n    #do-list-nav {\n        width: 100%;\n    }\n    #do-list-header {\n        width: 100%;\n        gap: 5%;\n        display: flex;\n        align-items: center;\n    }\n    #do-list-title {\n        font-size: 2.4rem;\n        /* font-family: 'Poppins Medium'; */\n        margin-right: auto;\n    }\n    .do-list-container {\n        width: 90%;\n        height: 100%;\n        margin-right: 5vw;\n    }\n    .do-list-subtitle {\n        font-size: 1.7rem;\n    }\n}\n@media (min-width:1281px) {\n    /* hi-res laptops and desktops */\n    #do-list-title {\n        font-size: 3rem;\n    }\n    .do-list-container {\n        width: 75%;\n    }\n    #do-list-nav {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
